const icons = {
  plus: `<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.38768 5.19383L1.00001 5.19384" stroke="black" stroke-width="2" stroke-linecap="round"/><path d="M5.19386 9.38767L5.19386 0.999994" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>`,
  minus: `<svg width="11" height="10" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.38768 1.19383L1.00001 1.19384" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>`,
};

function toggleDesktopMenuItemDropdown(event) {
  const menuItem = event.target.closest(".header__menu-desktop__item");
  const iconContainer = menuItem.querySelector(
    ".header__menu-desktop__dropdown-icon"
  );
  const isOpen = menuItem.classList.toggle("is-open");

  iconContainer.innerHTML = isOpen ? icons.minus : icons.plus;

  document
    .querySelectorAll(".header__menu-desktop__item.is-open")
    .forEach((item) => {
      if (item !== menuItem) {
        item.classList.remove("is-open");
        item.querySelector(".header__menu-desktop__dropdown-icon").innerHTML =
          icons.plus;
      }
    });
}

function handleClickOutsideDesktopMenuItemDropdown(event) {
  const dropdowns = document.querySelectorAll(
    ".header__menu-desktop__item.is-open"
  );

  dropdowns.forEach((dropdown) => {
    if (!dropdown.contains(event.target)) {
      dropdown.classList.remove("is-open");
      dropdown.querySelector(".header__menu-desktop__dropdown-icon").innerHTML =
        icons.plus;
    }
  });
}

document.addEventListener("click", (event) => {
  if (event.target.closest(".header__menu-desktop__item")) {
    toggleDesktopMenuItemDropdown(event);
  } else {
    handleClickOutsideDesktopMenuItemDropdown(event);
  }
});
